import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from '@fluentui/react-components';
import {
  Delete20Regular,
  Edit20Regular,
  MoreHorizontal20Regular,
} from '@fluentui/react-icons';
/**
 * Composant label pour le nœud Greeting
 * Ce composant est réactif et se met à jour quand callFlowData change
 */
const GreetingNodeLabel = ({ callFlowData, handleEditNode, handleDeleteNode }) => {
  const { t } = useTranslation();
  const greetingMessages = callFlowData?.greeting || {};
  const enabledMessages = Object.entries(greetingMessages).filter(
    ([key, msg]) => msg?.enabled === true
  );

  // Fonction pour formater le nom du message
  const formatMessageName = (key) => {
    const names = {
      welcomeMessage: 'welcome',
      emergencyMessage: 'emergency',
      flashMessage: 'flash',
      customMessage: 'custom'
    };
    return names[key] || key.replace('Message', '');
  };

  return (
    <div 
      className="node-greeting"
      onClick={() => handleEditNode('greeting')}
      style={{ cursor: 'pointer', position: 'relative' }}
    >
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <button
            className="node-menu-btn"
            onClick={(e) => e.stopPropagation()}
            title="Options"
          >
            <MoreHorizontal20Regular />
          </button>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleEditNode('greeting');
              }}
            >
              <Edit20Regular style={{ marginRight: '8px' }} />
              {t('EDIT')}
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteNode('greeting');
              }}
            >
              <Delete20Regular style={{ marginRight: '8px' }} />
              {t('DELETE')}
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
      <div className="node-title">{t('GREETING_MESSAGE')}</div>
      <div className="node-separator"></div>
      <div className="node-info">
        <div className="node-info-label">{t('ACTIVE_MESSAGES')}:</div>
        {enabledMessages.length === 0 ? (
          <div className="node-info-item" style={{ color: '#999', fontStyle: 'italic' }}>
            {t('NO_ACTIVE_MESSAGE')}
          </div>
        ) : (
          enabledMessages.map(([key]) => (
            <div key={key} className="node-info-item">
              {formatMessageName(key)}
            </div>
          ))
        )}
      </div>
    </div>
  );
};
export default GreetingNodeLabel;
